import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    _defineProperty(this, "_events", {});
  }

  _createClass(EventEmitter, [{
    key: "dispatch",
    value: function dispatch(event, data) {
      if (!this._events[event]) return;

      this._events[event].forEach(function (callback) {
        return callback(data);
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(event, callback) {
      if (!this._events[event]) this._events[event] = [];

      this._events[event].push(callback);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(event, callback) {
      if (!this._events[event]) return;
      this._events[event] = this._events[event].filter(function (item) {
        return item === callback;
      });
    }
  }]);

  return EventEmitter;
}();